<mat-label>Tags (click to copy)</mat-label>

<div class="row center report-tag-header" (click)="showComponentTypeTag=!showComponentTypeTag">
  <mat-icon>{{showComponentTypeTag ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}}</mat-icon>
  Component Type Wrapper Tag
</div>
<div class="report-tag-group" [ngClass]="{'show': showComponentTypeTag}">
  @for (tag of componentTypeTags | keyvalue; track tag.key) {
    <div>
      <button mat-raised-button (click)="copyToClipboard(tag.value[tag.key])"> {{tag.key}}</button>
      <br>
        <label>Filter by:</label>
        @for (wrapper of tag.value | keyvalue; track wrapper.key) {
          <div>
            @if (wrapper.key !==tag.key) {
              <button mat-raised-button
                (click)="copyToClipboard(wrapper.value)"> {{wrapper.key}}
              </button>
            }
          </div>
        }
      </div>
    }
  </div>

  <div class="row center report-tag-header" (click)="showComponentTypePropertyTags=!showComponentTypePropertyTags">
    <mat-icon>{{showComponentTypePropertyTags ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}}</mat-icon>
    Component Type Property Tags
  </div>
  <div class="report-tag-group" [ngClass]="{'show': showComponentTypePropertyTags}">
    @for (tag of componentTypePropertyTags | keyvalue; track tag.key) {
      <div>
        <button mat-raised-button (click)="copyToClipboard(tag.value)"> {{tag.key}}</button>
      </div>
    }
  </div>

  <div class="row center report-tag-header" (click)="showComponentRelationshipTags=!showComponentRelationshipTags">
    <mat-icon>{{showComponentRelationshipTags ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}}</mat-icon>
    Component Relationship Type Wrapper Tags
  </div>
  <div class="report-tag-group" [ngClass]="{'show': showComponentRelationshipTags}">
    @for (tag of componentTags | keyvalue; track tag.key) {
      <div>
        @if (tag.key) {
          <label>{{tag.key}}:</label><br>
          <button mat-raised-button (click)="copyToClipboard(tag.value[tag.key])"> {{tag.key}}</button>
          <br>
            <label>Filter by:</label>
            @for (wrapper of tag.value | keyvalue; track wrapper.key) {
              <div style="margin-left:10px;">
                @if (wrapper.key !==tag.key) {
                  <button mat-raised-button
                    (click)="copyToClipboard(wrapper.value)"> {{wrapper.key}}
                  </button>
                }
              </div>
            }
          }
        </div>
      }
    </div>

    <div class="row center report-tag-header" (click)="showComponentPropertyTags=!showComponentPropertyTags">
      <mat-icon>{{showComponentPropertyTags ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}}</mat-icon>
      Component Relationship Property Tags
    </div>
    <div class="report-tag-group" [ngClass]="{'show': showComponentPropertyTags}">
      @for (componentType of componentPropertyTags | keyvalue; track componentType.key) {
        <div>
          <label>{{componentType.key}}</label>
          @for (tag of componentType.value | keyvalue; track tag.key) {
            <div>
              <button mat-raised-button (click)="copyToClipboard(tag.value)"> {{tag.key}}</button>
            </div>
          }
        </div>
      }
    </div>

    <div class="row center report-tag-header" (click)="showSeriesTags=!showSeriesTags">
      <mat-icon>{{showSeriesTags ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}}</mat-icon>
      Series Tags
    </div>
    <div class="report-tag-group" [ngClass]="{'show': showSeriesTags}">
      @for (series of seriesTags | keyvalue; track series.key) {
        <div>
          <label>{{series.key}}</label>
          @for (tag of series.value | keyvalue; track tag.key) {
            <div>
              <button mat-raised-button (click)="copyToClipboard(tag.value)"> {{tag.key}}</button>
            </div>
          }
        </div>
      }
    </div>

    <div class="row center report-tag-header" (click)="showFunctionTags=!showFunctionTags">
      <mat-icon>{{showFunctionTags ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}}</mat-icon>
      Function Wrapper Tags
    </div>
    <div class="report-tag-group" [ngClass]="{'show': showFunctionTags}">
      @for (tag of functionTags | keyvalue; track tag.key) {
        <div>
          <button mat-raised-button (click)="copyToClipboard(tag.value)"> {{tag.key}}</button>
        </div>
      }
    </div>
